import { supabase } from '../lib/supabase'

export async function fetchSettlements() {
  const { data, error } = await supabase
    .from('settlements')
    .select(`
      *,
      payer:players!payer_id (*),
      payee:players!payee_id (*),
      game:games (game_name, course_name, created_at)
    `)
    .order('created_at', { ascending: false })

  if (error) throw error
  return data
}

export async function markSettled(id) {
  const { data, error } = await supabase
    .from('settlements')
    .update({
      settled: true,
      settled_at: new Date().toISOString(),
    })
    .eq('id', id)
    .select()
    .single()

  if (error) throw error
  return data
}

export async function markUnsettled(id) {
  const { data, error } = await supabase
    .from('settlements')
    .update({
      settled: false,
      settled_at: null,
    })
    .eq('id', id)
    .select()
    .single()

  if (error) throw error
  return data
}
